import { apiClient } from '../../gateways/api'
import type { FetchHoofdleidingOrganisationLists } from '../types/FetchHoofdleidingOrganisationLists'

export { fetchHoofdleidingOrganisationLists, initialState }

const initialState: FetchHoofdleidingOrganisationLists = {
  data: {
    netbeheerders: [],
    aannemers: [],
    verantwoordelijken: [],
    gebieden: [],
    labels: [],
    documentsoorten: [],
    mijlpalen: [],
    gebiedenForVerantwoordelijke: [],
  },
}

const fetchHoofdleidingOrganisationLists = async (): Promise<
  FetchHoofdleidingOrganisationLists['data']
> => {
  const { data } = await apiClient({
    url: '/rest/hoofdleiding/lists/organisation',
    method: 'GET',
  })
  return data
}
